<template>
  <div class="day-flow-container">
    <div class="content">
      <div class="title">
        <span>{{ dayStr }}分成</span>
        <span>
          <span>{{ currentIncomeInYuan }}</span>
          <span class="price-unit">元</span>
        </span>
      </div>
      <div
        v-if="total"
        class="profit-list"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getDetail"
        >
          <ProfitTable>
            <tbody>
              <tr>
                <th>时间</th>
                <th>类型</th>
                <th>流水</th>
                <th>我的分成</th>
              </tr>
              <tr
                v-for="flow in settleFlowVOList"
                :key="flow.tradeNO"
              >
                <td class="date-time">
                  {{ flow.billTime }}
                </td>
                <td>{{ flow.billType }}</td>
                <td>{{ flow.flowFeeInYuan }}元</td>
                <td>{{ flow.incomeInYuan }}元</td>
              </tr>
            </tbody>
          </ProfitTable>
        </van-list>
      </div>
    </div>
    <NoData
      v-if="!total"
      tips="没有找到相关记录"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import List from 'vant/lib/list';
import NoData from '@/components/NoData';
import ProfitTable from '@/components/ProfitTable';
import ProfitApi from '@/api/profit';
import STATUS from '@/constants/status';

import 'vant/lib/list/style';

Vue.use(List);

export default {
  name: 'DayProfit',
  components: {
    NoData,
    ProfitTable,
  },
  data() {
    return {
      pageNO: 1,
      pageCount: 1,
      pageSize: 20,
      total: 0,
      day: '',
      dayStr: '',
      settleFlowVOList: [],
      loading: false,
      finished: false,
      currentIncomeInYuan: '',
    };
  },
  computed: {
    ...mapState(['currentPoi']),
  },
  mounted() {
    const { day } = this.$route.query;
    const dayArr = day.split('-');
    this.dayStr = `${dayArr[1]}月${dayArr[2]}日`;
    this.day = day.replace(/-/g, '');
    this.getDetail();
  },
  methods: {
    async getDetail() {
      this.loading = true;
      const { poiId } = this.currentPoi;
      if (this.total && this.pageNO >= this.pageCount) {
        this.finished = true;
      }
      const res = await ProfitApi.getFlowInPage(poiId, this.day, this.pageNO);
      const { respCode, data } = res || {};
      if (respCode === STATUS.SUCCESS && data) {
        this.pageNO += 1;
        this.currentIncomeInYuan = data.currentIncomeInYuan;
        this.settleFlowVOList = [...this.settleFlowVOList, ...data.settleFlowVOList];
        this.total = data.totalCount;
        this.pageCount = Math.ceil(data.totalCount / this.pageSize);
      }
      this.loading = false;
    },
  },
};
</script>
<style  lang="scss" scoped>
  .day-flow-container {
    padding-bottom: 170px;
    .content {
      margin: 18px;
      padding-left: 36px;
      border-radius: 12px;
      background: #fff;
    }
    .title {
      background: #fff;
      display: flex;
      justify-content: space-between;
      padding: 30px 36px 30px 0;
      font-size: 32px;
      font-weight: bold;
      color: rgba(0,0,0,0.84);
      border-radius: 12px 12px 0 0;
      .price-unit {
        margin-left: 6px;
        font-size: 24px;
      }
    }
    .profit-list {
      padding: 36px 36px 0 0;
      border-top: 1px solid rgba(0,0,0,0.12);
      background: #fff;
      border-radius:  0 0 12px 12px;
      .profit-table-container {
        th {
          width: auto;
        }
      }
    }
  }
</style>
